import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ApiRequestService } from 'idt-ecommerce-api/_api/api-util/api-request.service';

import { ApiShippingMethodList } from './models/api-shipping.models';


export interface ApiShippingServiceInterface {
  getShippingMethodsUnique(
    storeId: string,
    languageId: string,
  ): Observable<ApiShippingMethodList>;
}

@Injectable()
export class ApiShippingService implements ApiShippingServiceInterface {

  constructor(
    private readonly http: HttpClient,
    private readonly requestService: ApiRequestService
  ) { /* empty */ }

  public getShippingMethodsUnique(
    storeId: string,
    languageId: string
  ): Observable<ApiShippingMethodList> {
    const slug = `order/store/${storeId}/shipping/unique`;
    const options = {
      withCredentials: true
    };
    return this.requestService.requestUrl(slug, languageId).pipe(
      switchMap((url: string) => this.http.get<ApiShippingMethodList>(url, options))
    );
  }

}
